export class XNSError extends Error {
    status: number;
    title: String;

    constructor({ title, message, status = 400 }: { title?: string, message: any, status: number}) {
        super(message);

        this.name = 'XNSError';
        this.status = status;
        this.title = title || "XNS Error"
    }
}
